
<template>

  <div>
    <div :class="this.mainDiv" v-if="successFlag"
    >

      <!--    <div class="sidebar__bg"-->
      <!--         v-bind:style="{ backgroundImage: 'url(' + this.imagePath + ')' }">-->

      <div class="center">
        <div class="box">
          <el-row>
            <div style="margin-top: 170%" >
              <br>
            </div>

            <el-input v-model="mo" placeholder="Username"  ></el-input>

          </el-row>

        </div>
      </div>
    </div>


    <div class="failBody" v-if="failFlag">
      <div class="center">
        <div class="box">

          <img src="./assets/fail.png"  style="margin-top: 50px;width: 300px">
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import Axios from 'axios';

export default {

  created() {
    console.log  ("mobile  this.$route.query.Auth : " + this.$route.query.Auth );
    this.authCode =  this.$route.query.Auth;
    this.geolocate();
  },
  data(){
    return {
      authCode : '',
      authKey : '',
      chkFlag : '',
      checkCount : '',
      latitude : '',
      longitude : '',
      successFlag : false,
      failFlag : false,
      mainDiv : 'mainBody1',
      imagePath : 'http://localhost:8080/assets/pda_main.png'

    }
  },
  methods:{

    // mounted() {
    //   this.geolocate();
    // },

    async test(){


    },

    async chkQrCode(){
      this.loading = true;
      // default data
      let url = this.$url + '/rfidInfo/chkQrCode';
      var reqJson = new Object();
      reqJson.auth_code = this.authCode
      reqJson.latitude = this.latitude
      reqJson.longitude = this.longitude
      reqJson.formatted_address = this.formatted_address;
      reqJson.country = this.country;
      reqJson.administrative_area_level_1 = this.administrative_area_level_1;

      await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
        var resDataJson = res.data.rfidInfoDTO;

        for(var resData in resDataJson){
          this.authKey =  resDataJson[resData]['auth_key'];
          this.chkFlag =  resDataJson[resData]['chk_flag'];
          this.checkCount =  resDataJson[resData]['check_count'];
          this.mainDiv = "mainBody" + resDataJson[resData]['rfid_get_order_seq'];
        }

        if (this.chkFlag =="false")
        {
          this.$message.success("가품으로 의심됩니다.");
          this.successFlag = false;
          this.failFlag = true;
        }else {
          this.$message.success("정품 입니다.");
          this.successFlag = true;
          this.failFlag = false;
        }
        this.loading = false;
      }) // await Axios.post
          .catch(error => {

            this.successFlag = false;
            this.failFlag = true;

            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post
    },//chkQrCode

    async geolocate() {
      navigator.geolocation.getCurrentPosition(position => {

        console.log ("geolocategeolocategeolocategeolocategeolocate ")

        this.latitude =  position.coords.latitude;
        this.longitude = position.coords.longitude;


        let url2  = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+this.latitude +","+ this.longitude  +"&key=AIzaSyA1LUF3e_P4F_vrT24zIJDy9p96eRJQmdg&language=ko"
//https://maps.googleapis.com/maps/api/geocode/json?latlng=40.714224,-73.961452&key=AIzaSyBqTiTAdFgE-yTQ8_FHtm961uCL-DEWXAo
        Axios.get(url2 ).then(res => {

          this.formatted_address = res.data['results'][0]['formatted_address'] ;

          for(var i=0 ; i< res.data['results'][0]['address_components'].length   ; i++) {

            if (res.data['results'][0]['address_components'][i]['types'][0] == "country")
              this.country= res.data['results'][0]['address_components'][i]['long_name']   ;

            if (res.data['results'][0]['address_components'][i]['types'][0] == "administrative_area_level_1")
              this.administrative_area_level_1 = res.data['results'][0]['address_components'][i]['long_name']  ;
          }

          this.chkQrCode();
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
            }); // await Axios.post


      });

    },


  }
}
</script>


<style>

/*@media all and (max-width: 1024px) and (min-width: 768px) {*/
/*  div {*/
/*    width: 60%;*/
/*  }*/
/*}*/

.mainBody1 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}

.mainBody2 {
  background-image: url('./assets/2.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}

.mainBody3 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}


.mainBody4 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}


.mainBody5 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}

.mainBody6 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}

.mainBody7 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}

.mainBody8 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}


.mainBody9 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}

.mainBody10 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}

.mainBody11 {
  background-image: url('./assets/pda_main.png');
  background-size: cover;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}


.failBody {
  /*background-image: url('./assets/fail.png');*/
  background-size: cover;
  height: 80vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
}

/*.box {*/
/*  flex: 1;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  height: 550px;*/
/*}*/

.menu-button {
  text-align: center !important;
  justify-content: center !important;
  align-items: center !important;
  margin-bottom: 0px !important;
  width: 300px !important;
  height: 50px !important;
  border-radius: 4px !important;
  color: #fff !important;
  padding: 10px 20px !important;
  box-sizing: border-box !important;
}




</style>



